import React, { useCallback, useEffect, useState } from 'react';
import { View, Text, Image } from 'react-native';

import api from '../services/api';

const ClienteCartelaID = ({ navigation }) => {
  const [cartelas, setCartelas] = useState([]);
  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [nomeSorteio, setNomeSorteio] = useState('');

  const selecionaCompra = useCallback(async () => {
    const urlMatch = window.location.href
      .toString()
      .match(/\/cartelas\/(\d+)\/(\d+)/);
    if (!urlMatch) {
      setNome('URL inválida');
      setWhatsapp('');
      setCartelas([]);
      return;
    }

    const [, sorteio_id, cliente_id] = urlMatch;

    try {
      const { data } = await api.get(
        `sorteios/${sorteio_id}/clientes/${cliente_id}`
      );

      const { data: sorteioData } = await api.get(`sorteios/${sorteio_id}`);
      setNomeSorteio(sorteioData.nome || '');

      if (data && data.cliente && data.cartelas) {
        setNome(data.cliente.nome || '');
        setWhatsapp(data.cliente.whatsapp || '');
        setCartelas(data.cartelas || []);
      } else {
        console.error('Dados não encontrados');
        setNome('Cliente não encontrado');
        setWhatsapp('');
        setCartelas([]);
      }
    } catch (error) {
      console.error('Erro ao buscar cartelas:', error);
      setNome('Erro ao carregar cartelas');
      setWhatsapp('');
      setCartelas([]);
    }
  }, []);

  useEffect(() => {
    selecionaCompra();
  }, []);

  return (
    <div id="paginaprint" style={{ flex: 1, width: '100%' }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View style={{ alignItems: 'center' }}>
          <Image
            style={{
              height: 200,
              width: 200,
              marginTop: -50,
              marginBottom: -50,
            }}
            source={require('../assets/logo.png')}
          />
        </View>

        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
            flexDirection: 'row',
          }}
        >
          <View style={{ flex: 1 }}>
            <View>
              <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Nome Cliente
              </Text>
              <Text style={{ textAlign: 'center' }}>{nome}</Text>
            </View>
          </View>
          <View style={{ flex: 1 }}>
            <View>
              <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Whatsapp
              </Text>
              <Text style={{ textAlign: 'center' }}>{whatsapp}</Text>
            </View>
          </View>
        </View>

        {cartelas.length > 0 ? (
          cartelas.map((e, index) => (
            <View
              key={e.id || index}
              onPress={() =>
                navigation.navigate('ClientesCartelas', { dados: e })
              }
              style={{
                backgroundColor: nomeSorteio.toLowerCase().includes('show')
                  ? '#fef3c7'
                  : '#fff',
                padding: nomeSorteio.toLowerCase().includes('show') ? 15 : 10,
                borderRadius: nomeSorteio.toLowerCase().includes('show')
                  ? 10
                  : 5,
                flexDirection: 'row',
                marginTop: 10,
                borderWidth: nomeSorteio.toLowerCase().includes('show') ? 2 : 0,
                borderColor: nomeSorteio.toLowerCase().includes('show')
                  ? '#f59e0b'
                  : 'transparent',
                shadowColor: nomeSorteio.toLowerCase().includes('show')
                  ? '#f59e0b'
                  : 'transparent',
                shadowOffset: nomeSorteio.toLowerCase().includes('show')
                  ? { width: 0, height: 2 }
                  : { width: 0, height: 0 },
                shadowOpacity: nomeSorteio.toLowerCase().includes('show')
                  ? 0.25
                  : 0,
                shadowRadius: nomeSorteio.toLowerCase().includes('show')
                  ? 4
                  : 0,
                elevation: nomeSorteio.toLowerCase().includes('show') ? 3 : 0,
              }}
            >
              <View>
                <Image
                  style={{
                    height: e.numeros && e.numeros.length > 3 ? 100 : 150,
                    width: e.numeros && e.numeros.length > 3 ? 100 : 150,
                  }}
                  source={require('../assets/logo.png')}
                />
                <Text
                  style={{
                    fontSize: nomeSorteio.toLowerCase().includes('show')
                      ? 12
                      : 9,
                    textAlign: 'center',
                    marginTop: 5,
                    fontWeight: nomeSorteio.toLowerCase().includes('show')
                      ? 'bold'
                      : 'normal',
                    color: nomeSorteio.toLowerCase().includes('show')
                      ? '#92400e'
                      : '#000',
                    backgroundColor: nomeSorteio.toLowerCase().includes('show')
                      ? '#fef3c7'
                      : 'transparent',
                    padding: nomeSorteio.toLowerCase().includes('show') ? 5 : 0,
                    borderRadius: nomeSorteio.toLowerCase().includes('show')
                      ? 5
                      : 0,
                    borderWidth: nomeSorteio.toLowerCase().includes('show')
                      ? 1
                      : 0,
                    borderColor: nomeSorteio.toLowerCase().includes('show')
                      ? '#f59e0b'
                      : 'transparent',
                  }}
                >
                  {e.id}
                </Text>
              </View>

              <View style={{ flex: 1 }}>
                {e.numeros && Array.isArray(e.numeros) ? (
                  e.numeros.map((numero, numIndex) => (
                    <View key={numIndex} style={{ alignItems: 'center' }}>
                      <Text
                        style={{
                          textAlign: 'center',
                          borderWidth: 1,
                          fontSize: nomeSorteio.toLowerCase().includes('show')
                            ? 20
                            : 18,
                          borderColor: nomeSorteio
                            .toLowerCase()
                            .includes('show')
                            ? '#f59e0b'
                            : '#95a5a6',
                          backgroundColor: nomeSorteio
                            .toLowerCase()
                            .includes('show')
                            ? '#fff'
                            : 'transparent',
                          color: nomeSorteio.toLowerCase().includes('show')
                            ? '#92400e'
                            : '#000',
                          fontWeight: nomeSorteio.toLowerCase().includes('show')
                            ? 'bold'
                            : 'normal',
                          padding: 5,
                          paddingLeft: 30,
                          paddingRight: 30,
                          borderRadius: 10,
                          margin: 5,
                        }}
                      >
                        {numero}
                      </Text>
                    </View>
                  ))
                ) : (
                  <Text style={{ textAlign: 'center', marginTop: 20 }}>
                    Números não disponíveis
                  </Text>
                )}
              </View>
            </View>
          ))
        ) : (
          <View
            style={{
              backgroundColor: '#fff',
              padding: 20,
              borderRadius: 5,
              marginTop: 10,
            }}
          >
            <Text style={{ textAlign: 'center' }}>
              Nenhuma cartela encontrada
            </Text>
          </View>
        )}
      </View>
    </div>
  );
};

export default ClienteCartelaID;
